//var isSP = (/iphone|ipod|ipad|android/i).test(navigator.userAgent);
//var breakPoint = 769;
//var isSP = window.innerWidth < breakPoint;
//var isPC = !isSP;
var isScrolling = false;
$(function () {

  //==============================================//
  // anchor 固定header高さ分位置調整
  //==============================================//
  $('[data-fancybox]').fancybox({
    buttons: ['zoom', 'close']
  });
  //==============================================//
  // gnavi fixed
  //==============================================//
  var $gnavi = $('#js-gnavi');
  var gnaviDefPos = $gnavi.offset().top;
  $(window).on('scroll', function () {
    var scrollNum = $(window).scrollTop();
    if (scrollNum >= gnaviDefPos && !$gnavi.hasClass('is-fixed')) {
      $gnavi.addClass('is-fixed');
    } else if (scrollNum < gnaviDefPos) {
      $gnavi.removeClass('is-fixed');
    }
  });
  //==============================================//
  // ticker
  //==============================================//
  var $newsList = $('#js-ticker'),
    newsW = 0,
    canMove = true,
    si,
    newsMinW = $('.p-news__lane').width(),
    newsMovePxPerSecond = newsMinW * 0.05;
  $newsList.on('mouseenter mouseleave',
      function () {
        canMove = !canMove;
      })
    .children().each(function (i, elm) {
      newsW += elm.clientWidth;
    });
  newsW = (newsW > newsMinW) ? newsW : newsMinW; //総合移動量
  si = setInterval(function () {
    if (canMove) {
      $newsList.css('left', '-=3');
      if (newsW < parseInt($newsList.css('left')) * -1) {
        $newsList.css('left', '100%');
      }
    }
  }, 33);

  //==============================================//
  // slide
  //==============================================//

  var $slide = $('#js-slide'),
    slideDly = 2000,
    stSlide;
  function changeSlide() {
    stSlide = setTimeout(function () {
      var $next = $slide.children().eq(0).fadeTo(0, 0.5);
      $next.appendTo($slide).fadeTo(400, 1);
      changeSlide();
    }, slideDly);
  }
  changeSlide();

  //==============================================//
  // reveal
  //==============================================//
  var controller = new ScrollMagic.Controller();
  var revealEl = $('[data-scroll-item]');
  revealEl.each(function (i, el) {
    new ScrollMagic.Scene({
        triggerElement: el,
        triggerHook: 0.9,
        //reverse: false
      })
      .setClassToggle(el, "is-active")
      .addTo(controller);
  });

  //gnavi
  var $revealEl2 = $('[data-linked-gnavi]');
  $revealEl2.each(function (i, el) {
    var navi = $('[href="#' + el.id + '"]').closest('li')[0];
    var preNavi;
    if (i !== 0) {
      preNavi = $('[href="#' + $revealEl2.eq(i - 1)[0].id + '"]').closest('li')[0];
    }
    new ScrollMagic.Scene({
        triggerElement: el,
        triggerHook: 0.25,
      })
      .on("enter leave", function (event) {
        $([navi, preNavi]).toggleClass('is-selected');
      })
      //      .addIndicators({
      //        name: "digit " + (el.id)
      //      })
      .addTo(controller);
  });


  //==============================================//
  // pagetop
  //==============================================//
  var showFlg = false;
  var $btnPagetop = $('#js-btnPageTop');
  var hidePos = -300;
  var showPos = 20;
  var speed = 200;
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      if (showFlg === false) {
        showFlg = true;
        $btnPagetop.animate({
          'bottom': showPos
        }, speed);
      }
    } else if (showFlg) {
      showFlg = false;
      $btnPagetop.animate({
        'bottom': hidePos
      }, speed);
    }
  });

  //==============================================//
  // anchor 固定header高さ分位置調整
  //==============================================//
  $('body').on('click', 'a[href^="#"]:not(.no-scroll)', function (e) {
    e.preventDefault();
    anchorScroll($(this).attr("href"));
    return false;
  });
  if (location.href.indexOf('#') !== -1) {
    window.addEventListener('load', function () {
      anchorScroll('#' + location.href.split('#')[1]);
    })
  }

  function anchorScroll(href) {
    //var href = $(this).attr("href");//
    var fixedHeader = $gnavi[0];
    var speed = 200;
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - (fixedHeader ? fixedHeader.offsetHeight : 0);
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
  }

  //==============================================//
  // rollover
  //==============================================//
  //	var elem_btn_off = 'a img[src*="_off."], input[src*="_off."]';
  //	var elem_btn_on = 'a img[src*="_on."], input[src*="_on."]';
  //	// preload
  //	$(elem_btn_off).each(function () {
  //		var newPath = $(this).attr('src').replace("_off.", "_on.");
  //		$('<img>').attr('src', newPath);
  //	});
  //	// over setting
  //	$('body').on("mouseenter", elem_btn_off, function (e) {
  //		var next = $(e.target).attr('src').replace(/^(.+)_off(\..+)$/, '$1_on$2');
  //		$(e.target).attr('src', next);
  //	});
  //	// out setting
  //	$('body').on("mouseleave", elem_btn_on, function (e) {
  //		var prev = $(e.target).attr('src').replace(/^(.+)_on(\..+)$/, '$1_off$2');
  //		$(e.target).attr('src', prev);
  //	});

});
